import { PoMenuItem } from '@po-ui/ng-components';
import { environment } from '@environments/environment';

export const ApplicationMenu: readonly PoMenuItem[] = [
  {
    label: 'l-home-page-name',
    shortLabel: 'l-home-page-name',
    link: 'home',
    icon: 'an an-house-line',
  },
  {
    label: 'l-applicant-registration',
    shortLabel: 'l-applicant-registration',
    link: 'applicant/registration',
    icon: 'an an-clipboard-text',
  },
  {
    label: 'l-job-opportunity-menu',
    shortLabel: 'l-job-opportunity-menu',
    link: 'job-opportunity',
    icon: 'an an-users',
  },
  {
    label: 'l-tests-menu',
    shortLabel: 'l-tests-menu',
    link: 'tests',
    icon: 'an an-file-text',
  },
  {
    label: 'l-job-portal-menu',
    shortLabel: 'l-job-portal-menu',
    link: environment.jobPortalUrl,
    icon: 'an an-magnifying-glass',
  },
];
